"use client";

import Image from 'next/image';
import Text from '@components/atoms/Text';
import PlatformLoader from '@components/atoms/PlatformLoader/PlatformLoader';
import { LoaderProps } from './Loader.types';
import styles from './Loader.module.scss';
import assetLoader from '@utils/internalImageLoder';
import { inApp } from '@utils/platformDetection.client';

const Loader: React.FC<LoaderProps> = ({
  theme = 'light',
  text = 'Loading...',
  subText,
  variant = 'center',
  className,
  customStyle,
  size = 'medium',
  forAppListing = false,
}) => {
  const isInApp = inApp();

  const getSizeStyles = () => {
    const sizeMap = {
      small: { width: '60px', height: '60px' },
      medium: { width: '80px', height: '80px' },
      large: { width: '120px', height: '120px' }
    };
    return sizeMap[size];
  };

  const containerClasses = [
    styles.container,
    styles[`${variant}Container`],
    styles[size],
    className
  ].filter(Boolean).join(' ');

  const loaderWidth = parseInt(getSizeStyles().width, 10);
  const loaderHeight = parseInt(getSizeStyles().height, 10);

  return (
    <div className={containerClasses} style={customStyle}>
      {isInApp ? (
        <PlatformLoader
          width={loaderWidth}
          height={loaderHeight}
          className={styles.loaderLottie}
        />
      ) : (
        <Image
          src={`${assetLoader()}/Loader/Car-Loader-${theme == 'dark' ? 'Dark' : 'Light'}.gif`}
          alt="Loading..."
          width={loaderWidth}
          height={loaderHeight}
          className={styles.loaderGif}
          unoptimized
          priority
        />
      )}
      {(!isInApp || forAppListing) && (
        <Text className={styles.loadingText}>{text}</Text>
      )}
      {!isInApp && subText && (
        <Text className={styles.loadingSubText}>{subText}</Text>
      )}
    </div>
  );
};

export default Loader;
